import { render } from "./ProfileButton.vue?vue&type=template&id=0d55e8ba"
import script from "./ProfileButton.vue?vue&type=script&lang=ts"
export * from "./ProfileButton.vue?vue&type=script&lang=ts"
script.render = render

export default script